import { FC, useEffect, useState } from "react"

import { Form, Row, Card } from "antd"

import { AnalyticsBarChart } from "@/components/Analytics/AnalyticsBarChart"
import { AnalyticsLineChart } from "@/components/Analytics/AnalyticsLineChart"
import {
  useCustomerAnalyticsHeader
} from "@/components/Analytics/AnalyticsSettings/CustomerAnalytics/useCustomerAnalyticsHeader"
import { getAnalyticsPriceExcel } from "@/http/analytics"
import classes from "@/pages/Analytics/Common/Analytics.module.scss"
import AnalyticsHeader from "@/pages/Analytics/Common/AnalyticsHeader"
import AnalyticsTitle from "@/pages/Analytics/Common/AnalyticsTitle"

import { usePricesAnalyticsQuery } from "@/hook/Analytics/useAnalyticsQuery"
import { useDownloadFile } from "@/hook/useDownloadFile"

import { IAnalyticsPageDisplayUnit } from "@/types/IAnalytics"
import { IDictionary } from "@/types/ui"

import { formatNumber } from "@/utils/formatNumber"

const displayUnits = [{
    label: "Цена",
    value: "price",
    bigLabel: "Цена"
}]

const AnalyticsPricePage: FC = () => {
  const [form] = Form.useForm()
  const { optionsList, component: HeaderComponent, isComparison } = useCustomerAnalyticsHeader({
    baseDisplayUnits: [],
    additionalDisplayUnits: displayUnits
  })

  const { data: analyticsPriceData } = usePricesAnalyticsQuery({ optionsList })

  const [analyticsMapped, setAnalyticsMapped] = useState<IDictionary<number | string>[]>()

  const [displayUnit, setDisplayUnit] = useState<IAnalyticsPageDisplayUnit>(displayUnits[0])
  

  const [uniqueFuels, setUniqueFuels] = useState<IAnalyticsPageDisplayUnit[]>([])

  const { download: excelDownload } = useDownloadFile(() => getAnalyticsPriceExcel({
      optionsList
    })
  )

  useEffect(() => {
    const data = analyticsPriceData?.response.data

    if (!data)
      return

    const fuelsSet = new Set<string>()

    const array = data.map(a => {
      const newDictionary: IDictionary<string | number> = {}
      newDictionary["period"] = a.period
      a.fuels?.forEach(f => {
        fuelsSet.add(f.fuelTypeName)
        newDictionary[f.fuelTypeName] = parseFloat(formatNumber(f.price))
      })

      return newDictionary
    })

    array.forEach(x => {
      if (Object.keys(x).length - 1 < fuelsSet.size){
        fuelsSet.forEach(y => {
          if(!(y in x)) {
            x[y] = 0
          }
        })
      }
    })

    setAnalyticsMapped(array)

    setUniqueFuels(Array.from(fuelsSet.values()).sort().map(f => ({
      value: f,
      label: "",
      bigLabel: `${displayUnit.bigLabel} (${f})`
    })))
  }, [displayUnit, analyticsPriceData])

  return (
    <>
      <Form form={form}>
        <AnalyticsTitle 
          text={"Динамика цен"}
        />

        <AnalyticsHeader 
          displayUnits={displayUnits}
          activeUnit={displayUnit}
          component={HeaderComponent}
          onChangeTabs={setDisplayUnit}
          onExcelDownload={excelDownload}
        />

        <Card bordered={false} className={ classes.cardWithTabs }> 
          <Row style={{ marginTop: "12px" }}>
            {
              !isComparison &&
                <AnalyticsLineChart data={analyticsMapped} dataKeys={uniqueFuels}/>
            }
            {
              isComparison &&
                <AnalyticsBarChart data={analyticsMapped} dataKeys={uniqueFuels}/>
            }
          </Row>
        </Card>
      </Form>
    </>
  )
}

export default AnalyticsPricePage
